export default __webpack_public_path__ + "/dist/images/2354117.png";